import { Outlet, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { SidebarProvider, SidebarInset } from './ui/sidebar';
import Header from './Header';
import AppSidebar from './Sidebar';
import {
  getToken,
  setToken,
  getSuperadminToken,
  clearSuperadminToken,
  getSuperadminRememberMe,
  clearSuperadminRememberMe,
} from '@/utils/storage';

const parseJwtPayload = (token) => {
  try {
    const binary = atob(token.split('.')[1]);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
    return JSON.parse(new TextDecoder('utf-8').decode(bytes));
  } catch {
    return null;
  }
};

const ImpersonationBanner = () => {
  const token = getToken();
  const payload = token ? parseJwtPayload(token) : null;
  if (!payload?.impersonated_by) return null;

  const handleReturn = () => {
    const superadminToken = getSuperadminToken();
    if (superadminToken) {
      setToken(superadminToken, getSuperadminRememberMe());
      clearSuperadminToken();
      clearSuperadminRememberMe();
    }
    window.location.href = '/superadmin';
  };

  return (
    <div className="bg-blue-600 text-white text-xs px-4 py-2 flex items-center justify-between flex-shrink-0">
      <span>
        👁 Mode impersonation
        {payload.school_name && (
          <>
            {' '}
            · <strong>{payload.school_name}</strong>
          </>
        )}
        <span className="opacity-60 ml-2">(connecté en tant que {payload.email})</span>
      </span>
      <button
        onClick={handleReturn}
        className="ml-4 px-3 py-1 rounded bg-white text-blue-700 font-semibold hover:bg-blue-50 transition-colors flex-shrink-0"
      >
        ← Retour superadmin
      </button>
    </div>
  );
};

const Layout = ({ children }) => {
  const location = useLocation();
  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset className="bg-gray-50 overflow-hidden">
        <ImpersonationBanner />
        <Header />
        <div className="relative flex-1 overflow-hidden">
          <AnimatePresence initial={false}>
            <motion.div
              key={location.pathname}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.15, ease: 'easeOut' }}
              className="absolute inset-0 overflow-y-auto p-4 lg:p-6"
            >
              {children || <Outlet />}
            </motion.div>
          </AnimatePresence>
        </div>
      </SidebarInset>
    </SidebarProvider>
  );
};

export default Layout;
